import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a hand holding a shield icon to represent a dispute adjusted.
 */
export function HandHoldingShieldIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7.99483C14 9.6783 16.1184 10.9245 17.0607 11.3957C17.3373 11.5349 17.6635 11.5348 17.9399 11.3953C18.8826 10.9238 21 9.68058 21 7.99483V5.59783C20.9919 5.33626 20.7878 5.12294 20.5268 5.10341C19.6406 5.02207 18.7924 4.70486 18.0702 4.18474C17.73 3.93842 17.2701 3.93842 16.9298 4.18474C16.2077 4.70486 15.3594 5.02207 14.4732 5.10341C14.2122 5.12292 14.0081 5.33625 14 5.59783V7.99483Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.98149 21.0037H3.99666C3.44423 21.0035 2.99645 20.5558 2.99625 20.0033V14.0008C2.99645 13.4484 3.44423 13.0006 3.99666 13.0004H5.98149C6.53392 13.0006 6.98171 13.4484 6.98191 14.0008V20.0033C6.98171 20.5558 6.53392 21.0035 5.98149 21.0037Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12.9604 17.0021H15.2854C15.7168 17.0021 16.1364 16.8617 16.4809 16.6019L18.8879 14.7892C19.4884 14.3369 20.3306 14.3971 20.8607 14.9302C21.4499 15.523 21.4499 16.4803 20.8607 17.0731L18.7958 19.147C18.2401 19.7052 17.5312 20.0861 16.759 20.2414L13.8388 20.8277C13.26 20.9439 12.6626 20.9295 12.09 20.7857L9.44993 20.1234C9.13402 20.0434 8.80939 20.0031 8.48353 20.0033H6.9819"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12.9604 17.0021H14.44C15.2754 17.0004 15.9513 16.3218 15.9496 15.4864V15.1833C15.9508 14.4891 15.4793 13.8832 14.8062 13.7137L12.5222 13.1405C12.1512 13.0475 11.7702 13.0004 11.3877 13.0004C10.4636 13.0003 9.56025 13.2751 8.79266 13.7897L6.9819 15.0012"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
